import React from "react";

import { withPrefix } from "gatsby";
import Layout from "../../components/Layout";
import BlogRoll from "../../components/BlogRoll";

export default class BlogIndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <div
          className="full-width-image-container margin-top-0"
          style={{
            backgroundImage: `url('${withPrefix("/")}img/blog-index.jpg')`,
            backgroundPositionY: "center",
          }}
        >
          <h1
            className="has-text-weight-medium is-size-1 has-background-primary-half-opaque m-b-md"
            style={{
              color: "white",
              padding: "1rem",
              lineHeight: "1.125",
            }}
          >
            Latest Updates
          </h1>
        </div>
        <section className="section">
          <div className="container">
            <div className="content">
              <BlogRoll />
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}
